import { Navigate } from 'react-router-dom';

import { useAuthContext } from '../../contexts/authContext';

type AdminRouteProps = {
  children: React.ReactNode;
};

const AdminRoute = ({ children }: AdminRouteProps) => {
  const { role, isAuthenticated } = useAuthContext();

  if (!isAuthenticated || role !== 'ADMIN') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
